import {
  SERVICE_LIST_FETCH,
  SERVICE_LIST_SUCCESS,
  SERVICE_LIST_FAILURE
} from './actionTypes';

import { ADD_SERVICE_TO_THE_LIST } from '../ServiceForm/actionTypes';

const initialState = {
  isLoaded: false,
  services: [],
  error: []
};

export const servicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SERVICE_LIST_FETCH:
      return { ...state, isLoaded: false };
    case SERVICE_LIST_SUCCESS:
      return { ...state, isLoaded: true, services: action.payload };
    case ADD_SERVICE_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        services: [...state.services, action.payload]
      };
    case SERVICE_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.serviceList.isLoaded;
export const getServices = state => state.serviceList.services;
export const getError = state => state.serviceList.error;



// WEBPACK FOOTER //
// ./src/modules/ServiceList/reducer.js